import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { WebsocketContext } from '../../../context/WebsocketContext';
import { formatDateToView } from '../../../functions/DateTime';
import * as FeedbackService from "../../../services/FeedbackService";
import { useAppSelector } from '../../../stores/hooks';
import { RootState } from '../../../stores/store';
import "./FeedbackCanvasHeader.scss";
import FeedbackUsersConnectionStatus from './FeedbackUsersConnectionStatus';
import { t } from 'i18next';
import CompleteFeedbackButton from '../../button/CompleteFeedbackButton/CompleteFeedbackButton';

const FeedbackCanvasHeader = (): React.JSX.Element => {
  const { disconnect } = useContext(WebsocketContext)
  const canvasStore = useAppSelector((state: RootState) => state.canvas)
  const navigate = useNavigate()
  const [feedback, setFeedback] = useState<IFeedback>(
    canvasStore.feedback || ({} as IFeedback)
  )

  useEffect(() => {
    setFeedback(canvasStore.feedback || ({} as IFeedback));
  }, [canvasStore])

  const disconnectCanvas = () => {
    new Promise<void>(resolve => {
      disconnect()
      console.info('Desconectado com sucesso!')
      return resolve()
    }).then(() => {
      console.info('Redirecionando para tela de Feedbacks')
      navigate("/feedbacks")
    })
  }


  const updateStatus = () => {
    const updatedFeedback = {
      ...feedback,
      status: "completed" as Status,
    };

    FeedbackService.update(
      updatedFeedback,
      (): void => {
      console.log("Status atualizado com sucesso!");
      },
      (error: unknown): void => {
      console.error("Erro ao atualizar status:", error);
      }
    );
  };



  const userRole = useMemo(() => {
    const sessionData = JSON.parse(localStorage.getItem("sessionData") ?? "{}");
    const userId = sessionData.id ?? null;

    if (!feedback || !feedback.users) return null;

    return feedback.users.find((user: IUser) => user.cognito_id === userId)?.role ?? null;
  }, [feedback]);

  return (
    <div className="canvas-header d-flex flex-row justify-content-between mt-0 mb-3 bg-gray">
      <FeedbackUsersConnectionStatus />

      <div className="d-flex flex-row gap-4">
        {
          feedback && feedback.schedule_date &&
          <div className="d-flex flex gap-4">
            <div className="d-flex gap-2 align-items-center text-center">
              <span>{t('board.date')}: </span>
              <p className="m-0">
                {formatDateToView(feedback.schedule_date)}
              </p>
            </div>
          </div>
        }
        <div className="d-flex flex  align-items-center gap-4">
          <Link
            to={"/feedbacks"}
            className="btn btn-outline-secondary flex-grow-1"
            onClick={disconnectCanvas}
          >{t('board.outBoard')}</Link>
          {userRole === "facilitator" && feedback.status !== "completed" && (
            <CompleteFeedbackButton
              feedbackCanvas={feedback}
              onStatusUpdate={setFeedback}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default FeedbackCanvasHeader
